import { render, staticRenderFns } from "./SoftWare.vue?vue&type=template&id=26bf9986&scoped=true&"
import script from "./SoftWare.vue?vue&type=script&lang=js&"
export * from "./SoftWare.vue?vue&type=script&lang=js&"
import style0 from "./SoftWare.vue?vue&type=style&index=0&id=26bf9986&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26bf9986",
  null
  
)

export default component.exports